import { render, staticRenderFns } from "./ActionView.vue?vue&type=template&id=0bff75b0&scoped=true&"
import script from "./ActionView.vue?vue&type=script&lang=js&"
export * from "./ActionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bff75b0",
  null
  
)

export default component.exports